@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.jobModeRadioGroup {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom:  hevo-toolkit-variables.$spacer * 2;
  border: solid  hevo-toolkit-variables.$border-width  hevo-toolkit-variables.$divider-color;
  border-radius:  hevo-toolkit-variables.$border-radius-default;
  & > :not(:first-child) {
    border-top: solid  hevo-toolkit-variables.$border-width  hevo-toolkit-variables.$divider-color;
  }
}

.jobModeSelectorBox {
  width: 100%;
  border: solid hevo-toolkit-variables.$border-width hevo-toolkit-variables.$divider-color;
  border-radius: hevo-toolkit-variables.$border-radius-4;
  transition: all 0.2s ease-in;
  margin-bottom:  hevo-toolkit-variables.$spacer * 2;

  .header {
    padding:  hevo-toolkit-variables.$spacer * 2  hevo-toolkit-variables.$spacer * 0.875  hevo-toolkit-variables.$spacer;
    width: 100%;

    .seeMoreBtn {
      text-decoration: none !important;
      box-shadow: none;
    }
  }

  .jobModeRadioGroupExperiment {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    & {
      border-top: none;
      padding-left:  hevo-toolkit-variables.$spacer * 0.75 !important;
    }
  }
}
